export default __webpack_public_path__ + "static/media/icons8-unread-messages.9ee5caa4.svg";